import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import MusicPlayerBar from "@/components/MusicPlayerBar";
import UploadModal from "@/components/UploadModal";
import NowPlayingBanner from "@/components/NowPlayingBanner";
import { usePlayer } from "@/context/PlayerContext";

export default function AppShell() {
  const [uploadOpen, setUploadOpen] = useState(false);
  const { current } = usePlayer();

  return (
    <div className="min-h-screen bg-[#0A0A0E] text-white">
      <Navbar onUpload={() => setUploadOpen(true)} />
      <main className={`pt-20 ${current ? "pb-32" : "pb-12"} min-h-screen`}>
        <NowPlayingBanner />
        <Outlet context={{ openUpload: () => setUploadOpen(true) }} />
      </main>
      <MusicPlayerBar />
      <UploadModal open={uploadOpen} onClose={() => setUploadOpen(false)} />
    </div>
  );
}
